import { render } from "./ShowLookupValue.vue?vue&type=template&id=496aa944"
import script from "./ShowLookupValue.vue?vue&type=script&lang=js"
export * from "./ShowLookupValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__